import {Injectable} from "@angular/core";
import {AbstractActionService} from "../../../../core/service/v2/service/action/abstractAction.service";
import {CustomizeHttpUrlGenerator} from "../../../../../store/core/url/customizeHttpUrlGenerator";
import {HttpClient} from "@angular/common/http";
import {Payload} from "../../../../core/service/payload/payload";

@Injectable()
export class ReportComponentGetDefaultService
    extends AbstractActionService<ReportComponentGetDefaultPayload, ReportComponentGetDefaultResult> {

    public constructor(customizeHttpUrlGenerator: CustomizeHttpUrlGenerator,
                       httpClient: HttpClient) {
        super('ReportComponent', 'get-default-component', customizeHttpUrlGenerator, httpClient);
    }
}

export class ReportComponentGetDefaultPayload implements Payload {
    userId: number;
    officeId: number;
}

export class ReportComponentGetDefaultResult {
    headerReportComponentId: number;
    signatureReportComponentId: number;
    footerReportComponentId: number;
}